import React from 'react';
import { Group, Modal } from '@mantine/core';
import { CancelButton } from './FormActionButtons';
import { getJlfcModalProps } from './jlfcModalConfig';

export { getJlfcModalProps, blockModalEnterKey } from './jlfcModalConfig';

export default function JlfcModal({
  styles,
  children,
  footer = null,
  showCloseFooter = false,
  closeFooterLabel = 'Fermer',
  onClose,
  ...props
}) {
  const { styles: baseStyles, ...modalDefaults } = getJlfcModalProps();

  const resolvedFooter =
    footer ??
    (showCloseFooter && onClose ? (
      <Group justify="flex-end">
        <CancelButton onClick={onClose}>{closeFooterLabel}</CancelButton>
      </Group>
    ) : null);

  const {
    content: contentStyle,
    header: headerStyle,
    title: titleStyle,
    body: bodyStyle,
    ...restStyles
  } = styles || {};

  // Évite le double scroll : le body des appelants ne doit pas scroller lui-même.
  const {
    overflow: _bodyOverflow,
    overflowY: _bodyOverflowY,
    overflowX: _bodyOverflowX,
    maxHeight: _bodyMaxHeight,
    ...safeBodyStyle
  } = bodyStyle || {};

  return (
    <Modal
      {...modalDefaults}
      styles={{
        ...baseStyles,
        ...restStyles,
        content: {
          maxHeight: 'calc(100dvh - 7rem)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          ...baseStyles?.content,
          ...contentStyle,
        },
        header: {
          flexShrink: 0,
          ...baseStyles?.header,
          ...headerStyle,
        },
        title: { ...baseStyles?.title, ...titleStyle },
        body: {
          flex: '1 1 auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          ...baseStyles?.body,
          ...safeBodyStyle,
          // Une seule zone de scroll (ci-dessous), pas le body Mantine.
          overflow: 'hidden',
          maxHeight: undefined,
          paddingBottom: resolvedFooter ? 0 : baseStyles?.body?.paddingBottom,
        },
      }}
      onClose={onClose}
      {...props}
    >
      <div
        style={{
          flex: '1 1 auto',
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollbarGutter: 'stable',
        }}
      >
        {children}
      </div>
      {resolvedFooter ? (
        <div
          style={{
            flexShrink: 0,
            marginTop: 'var(--mantine-spacing-md)',
            paddingTop: 'var(--mantine-spacing-md)',
            paddingBottom: 'var(--mantine-spacing-md)',
            borderTop: '1px solid var(--mantine-color-gray-3)',
            background: 'var(--mantine-color-body)',
          }}
        >
          {resolvedFooter}
        </div>
      ) : null}
    </Modal>
  );
}
